// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listCustomField' }],
    name: 'get-all-custom-fields',
    sort: ['+name'],
    extraData: ['deletable'],
});
